import React from 'react';
import { Box, TextField } from '@mui/material';

function PlanNamingFields({
    jobName = '',
    floorName = '',
    areaName = '',
    onJobNameChange,
    onFloorNameChange,
    onAreaNameChange,
    onFileNameSync,
    disabled = false,
    layout = 'row',
    fieldSx,
}) {
    const sync = (job, floor, area) => {
        onFileNameSync?.(job, floor, area);
    };

    const defaultFieldSx = layout === 'inline'
        ? { margin: '5px', width: '20%' }
        : { flex: 1, margin: layout === 'row' ? 1 : 0 };
    const fieldsContainerSx = layout === 'inline'
        ? undefined
        : { display: 'flex', flexDirection: layout === 'row' ? 'row' : 'column' };

    return (
        <Box sx={fieldsContainerSx}>
            <TextField
                variant="outlined"
                label="Job"
                required
                sx={fieldSx ?? defaultFieldSx}
                disabled={disabled}
                value={jobName}
                onChange={(event) => {
                    const value = event.target.value;
                    onJobNameChange?.(value);
                    sync(value, floorName, areaName);
                }}
            />
            <TextField
                variant="outlined"
                label="Floor"
                required
                sx={fieldSx ?? defaultFieldSx}
                disabled={disabled}
                value={floorName}
                onChange={(event) => {
                    const value = event.target.value;
                    onFloorNameChange?.(value);
                    sync(jobName, value, areaName);
                }}
            />
            <TextField
                variant="outlined"
                label="Area"
                sx={fieldSx ?? defaultFieldSx}
                disabled={disabled}
                value={areaName}
                onChange={(event) => {
                    const value = event.target.value;
                    onAreaNameChange?.(value);
                    sync(jobName, floorName, value);
                }}
            />
        </Box>
    );
}

export default PlanNamingFields;
